export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9336.31db9fa0.jpg";